export default __webpack_public_path__ + "static/media/certificate-template.1c0adb7a.png";